import React from 'react';

// Drag-and-drop was removed in favour of a single, uniformly-validated
// assignment path (unassign -> click empty cell -> pick staff -> validate).
// These two components are kept with their original names, props, and markup so
// the ~11 call sites and every onClick path continue to work unchanged -- only
// the drag mechanics and the drag animation (scale/rotate/ring) are gone.

export const DraggableEmployee = ({ id, name, className, style, onClick }) => {
  return (
    <div
      style={style}
      onClick={onClick}
      className={`${className} transition-all duration-200 ease-in-out ${onClick ? 'cursor-pointer hover:scale-105 active:scale-95' : ''}`}
    >
      <span className="truncate px-1">{name}</span>
    </div>
  );
};

export const DroppableSlot = ({ id, children, className, disabled, onClick }) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={`${className} transition-all duration-200 border-2 border-transparent ${onClick && !disabled ? 'hover:bg-gray-50' : ''}`}
    >
      {children}
    </div>
  );
};
